import store from 'redux/store'
import { getFinalPriceMdl22Service } from 'redux/services/clientsServices'

export const fethCheckFinalPrice = async (prod, customerId, newCompany) => {
  const company = store.getState().company
  const quoteHeader = store.getState().cotizacion.QuoteHeader

  const PriceListId = quoteHeader.PriceListId
  // Exclude warranty items from the price service call
  const regularProd = prod.filter(p => !p.product?.IsExtendedWarranty)
  const ProductIds = regularProd.map(product => product.product.ProductId)
  const WarehouseId = newCompany?.WarehouseId || company.WarehouseId
  const WarehouseCode = newCompany?.WarehouseCode || company.WarehouseCode
  const WarehouseDescription =
    newCompany?.WarehouseDescription || company.WarehouseDescription
  const CompanyId = newCompany?.CompanyId || company.CompanyId

  const warehouse = {
    WarehouseId,
    WarehouseCode,
    WarehouseDescription,
    WarehouseAddress: quoteHeader?.WarehouseAddress,
  }

  const mapByProductId = selectList =>
    selectList.map(item => {
      const product = regularProd.find(
        p => p.product.ProductId === item.ProductId
      )
      const Quantity = product ? product.qty : 0
      const Price = item.FinalPrice

      return {
        selectList: { ...item, Quantity, Price },
        payload: { ...product, Quantity, Price },
        warehouse,
        Quantity,
        Price,
        qty: Quantity,
      }
    })

  const isSaleOrderWeb = quoteHeader?.Origin === 'AB'

  if (!isSaleOrderWeb) {
    const finalPricePayload = {
      CompanyId,
      WarehouseId,
      ProductIds,
      ...(customerId ? { CustomerId: customerId } : { PriceListId }),
    }

    const response = await getFinalPriceMdl22Service(finalPricePayload)
    const { data, status } = response

    if (status === 200 && data?.Data) {
      return mapByProductId(data.Data)
    }
  } else {
    return mapByProductId(quoteHeader?.Lines)
  }
}

export const processWarranties = (warrantyProducts, newCompany) => {
  if (!warrantyProducts.length) return []

  const payload = warrantyProducts.map(prod => ({
    product: { ...prod },
    qty: prod.Quantity,
  }))

  return formatFinalPriceData(payload, warrantyProducts, newCompany)
}

export const buildFinalProductsInOrder = (
  allProducts,
  processedProducts,
  processedWarranties
) => {
  const groupedByProductId = new Map()

  processedProducts.forEach(procProd => {
    const productId = procProd.payload.product.ProductId
    if (!groupedByProductId.has(productId)) {
      groupedByProductId.set(productId, { products: [], warranties: [] })
    }
    groupedByProductId.get(productId).products.push(procProd)
  })

  processedWarranties.forEach(procWarranty => {
    const warrantyProductId = procWarranty.payload.product.WarrantyProductId
    if (!groupedByProductId.has(warrantyProductId)) {
      groupedByProductId.set(warrantyProductId, {
        products: [],
        warranties: [],
      })
    }
    groupedByProductId.get(warrantyProductId).warranties.push(procWarranty)
  })

  const finalOrderedProducts = []
  const processedProductIds = new Set()

  allProducts.forEach(prod => {
    if (prod.IsExtendedWarranty) return

    const productId = prod.ProductId
    if (processedProductIds.has(productId)) return

    const grouped = groupedByProductId.get(productId)
    if (!grouped) return

    grouped.products.forEach(p => finalOrderedProducts.push(p))
    grouped.warranties.forEach(w => finalOrderedProducts.push(w))

    processedProductIds.add(productId)
  })

  return finalOrderedProducts
}

export const formatFinalPriceData = (prod, selectList, newCompany) => {
  const company = store.getState().company
  const quoteHeader = store.getState().cotizacion.QuoteHeader

  const WarehouseId = newCompany?.WarehouseId || company.WarehouseId
  const WarehouseCode = newCompany?.WarehouseCode || company.WarehouseCode
  const WarehouseDescription =
    newCompany?.WarehouseDescription || company.WarehouseDescription

  const warehouse = {
    WarehouseId,
    WarehouseCode,
    WarehouseDescription,
    WarehouseAddress: quoteHeader?.WarehouseAddress,
  }

  return selectList.map((item, index) => {
    const product = prod[index] || {}
    const Quantity = product?.qty || 0
    const Price = item.FinalPrice

    return {
      selectList: { ...item, Quantity, Price },
      payload: { ...product, Quantity, Price },
      warehouse,
      Quantity,
      Price,
      qty: Quantity,
    }
  })
}
